<script setup>
import { computed } from 'vue';
import { Line } from 'vue-chartjs';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Legend,
} from 'chart.js';

const props = defineProps({
  collection: {
    type: Object,
    default: () => ({}),
  },
  showLegend: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['pointClick']);

ChartJS.register(
  Title,
  Tooltip,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Legend
);

const fontFamily =
  'Inter,-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif';

const chartData = computed(() => ({
  labels: props.collection.labels || [],
  datasets: props.collection.datasets || [],
}));

const options = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  animation: { duration: 0 },
  onClick: (event, elements) => {
    if (!elements?.length) return;
    const element = elements[0];
    emit('pointClick', {
      index: element.index,
      datasetIndex: element.datasetIndex,
    });
  },
  plugins: {
    legend: {
      display: props.showLegend,
      position: 'bottom',
      labels: { fontFamily, boxWidth: 12 },
    },
  },
  scales: {
    x: {
      ticks: { fontFamily },
      grid: { drawOnChartArea: false },
    },
    y: {
      beginAtZero: true,
      ticks: { fontFamily, stepSize: 1 },
      grid: { drawOnChartArea: false },
    },
  },
}));
</script>

<template>
  <Line :data="chartData" :options="options" />
</template>
